// extracted by mini-css-extract-plugin
export default {"root":"_1pYup","visible":"_1p2BO","overlay":"FYfxg","fixed":"_3awua","absolute":"_1mNwZ","content":"_3zgeQ","center":"_12coa"};